__turbopack_context__.v({
  "chip": "header-module-scss-module__Y5gNga__chip",
  "header": "header-module-scss-module__Y5gNga__header",
  "icon": "header-module-scss-module__Y5gNga__icon",
  "subtitle": "header-module-scss-module__Y5gNga__subtitle",
  "text": "header-module-scss-module__Y5gNga__text",
  "title": "header-module-scss-module__Y5gNga__title",
});
